import { useTranslation } from 'react-i18next';

const AboutSection = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  const scrollToValues = () => {
    const element = document.getElementById('values');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className={isRTL ? 'text-right' : 'text-left'}>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 font-almarai">
              {t('about.title')}
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed font-tajawal">
              {t('about.description')}
            </p>
            <button
              onClick={scrollToValues}
              className="bg-primary text-white px-8 py-4 rounded-full font-tajawal text-base hover:bg-primary-dark transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              {t('about.cta')}
              <i className={`ri-arrow-${isRTL ? 'left' : 'right'}-line`}></i>
            </button>
          </div>

          {/* Stats Card - Left side for Arabic (40%) */}
          <div className={`lg:col-span-2 ${isRTL ? 'lg:order-1' : 'lg:order-2'}`}>
            <div className="relative bg-gradient-to-br from-primary to-earth rounded-3xl p-12 shadow-xl">
              {/* Decorative Element */}
              <div className={`absolute top-6 ${isRTL ? 'left-6' : 'right-6'}`}>
                <i className="ri-more-fill text-white/30 text-2xl"></i>
              </div>

              {/* Main Stat */}
              <div className="text-center mb-8">
                <div className="font-almarai font-bold text-6xl text-white mb-2">100+</div>
                <div className="font-tajawal text-2xl text-white/90">{t('about.stat')}</div>
              </div>

              {/* Badge */}
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-6 flex items-center gap-4">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl text-primary"></i>
                </div>
                <div className={isRTL ? 'text-right' : 'text-left'}>
                  <div className="font-tajawal font-bold text-white text-lg">{t('about.badge')}</div>
                  <div className="font-tajawal text-white/80 text-sm">{t('about.since')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;